import { objToQueryString } from '../models/utils';
import { Injectable } from '@angular/core';
import { StoreHelper } from './store-helper';
import { Store } from './store';
import { ApiService } from './api.service';
import { Observable } from 'rxjs/Observable';
import { CanActivate, Router } from '@angular/router';
import { ConfigService } from './config.service';
import { UserToken, Account, User } from '../models';
import { UserService } from './user.service';
import { NativeChannelService } from './native-channel.service';
import { LocalStorageService } from './local-storage.service';
import { AccountsService } from './accounts.service';
import * as moment from 'moment';
import 'rxjs/Rx';


@Injectable()
export class AuthService implements CanActivate {
  BEARER_KEY: string = 'nova_bearer_info';

  private _userToken: UserToken;

  constructor(
    private storeHelper: StoreHelper,
    private api: ApiService,
    private _router: Router,
    private store: Store,
    private configService: ConfigService,
    private _userSvc: UserService,
    private _nativeChannelService: NativeChannelService,
    private _localStorageService: LocalStorageService,
    private _accService: AccountsService
  ) {
    this._userSvc.user$.subscribe(user => this._checkIfUserIsNull(user));
    let  userTokenJson = this._getUserLogged();
    if (userTokenJson) {
      this._userToken = new UserToken(userTokenJson);
      this.setBearer();
    }
  }

  get accessToken() {
    return this._userToken.token;
  }

  setBearer() {
    this.api.setHeaders({ Authorization: `Bearer ${this._userToken.token}` });
    // retrieve user info
    this._userSvc.updateUserInfo();
    this._nativeChannelService.setUserToken(this._userToken.token);
  }

  isAuthorized(): boolean {
    let isTokenValid = false;
    if (this._userToken) {
        isTokenValid = this._userToken.expires.isAfter(moment());
        //if theres is a user logged with token expired removed the account of this user form local storage;
        if (!isTokenValid) {
          this._accService.removeAccount(this._userToken.accountName);
        }
    }
    return isTokenValid;
  }

  canActivate(): boolean {
    const isAuth = this.isAuthorized();
    if (!isAuth) {
      this._router.navigate(['', 'accounts']);
    }
    return isAuth;
  }

  login(account: Account) {
      this._userToken = new UserToken(account);
      this.setBearer();
      this.storeHelper.update('user', this._userToken);
      this._localStorageService.set(this.BEARER_KEY, account);
  }

  switchAccount() {
      this._removeUserLogged();
  }

  authenticate(creds): Observable<any> {
    let auth = this.configService.getContext('auth');
    // convert company name to host value
    // TODO: I need to come back here and make this value dynamic
    creds.host = `https://${creds.account.replace(/_/g, '-')}.beta.novapointofsale.com`;
    creds.grant_type = 'password';

    let loginPayload = objToQueryString(creds);

    if (!creds.password) {
      loginPayload += '&password=';
    }

    return this.api.post(auth.url, 'token', loginPayload, true)
      .do((res: any) => {
        res.username = creds.username.toUpperCase();
        res.accountName = creds.account.toUpperCase();
        this._userToken = new UserToken(res);
        this.setBearer();
        this._accService.updateAccounts(new Account(res));
        this._localStorageService.set(this.BEARER_KEY, res);
      })
      .do(res => this.storeHelper.update('user', this._userToken))
      .map(res => res);
  }

  signout(account: Account, redirect = false) {
    if (!account) {
      return;
    }

    this._accService.removeUserTokenFromAccount(account);

    if (redirect) {
      this._router.navigate(['', 'accounts']);
    }
  }

  removeAccount(account: string) {
    if (!account) {
      return;
    }

    this._accService.removeAccount(account);

    let userTokenJson = this._localStorageService.get(this.BEARER_KEY);
    if (userTokenJson && this._accService.accountsEquals(userTokenJson.accountName, account)) {
         this._removeUserLogged();
    }
  }

  private _removeUserLogged() {
      this._removeCurrentUserFromLocalStore();
      this._userToken = null;
      this._userSvc.removeUser();
      this.store.purge();
  }

  private _getUserLogged() {
      let accounts = this._accService.getAccounts();
      const userTokenJson = this._localStorageService.get(this.BEARER_KEY);

      if (!userTokenJson || !userTokenJson.accountName || accounts.length < 1)  {
          this._removeCurrentUserFromLocalStore();
          return null;
      }

      //get account to current user 
      let account = this._accService.getAccountByName(userTokenJson.accountName);
      if (!account) {
        //remove user if does not belong to account in local storage
        this._removeCurrentUserFromLocalStore();
        return null;
      }
      return userTokenJson;
   }

   private _removeCurrentUserFromLocalStore() {
     this._localStorageService.remove(this.BEARER_KEY);
   }

   private _checkIfUserIsNull(user: User) {
      if (user && !user.isTokenValid) {
        let redirectToLogin = false;

        const userTokenJson = this._localStorageService.get(this.BEARER_KEY);
        if (userTokenJson && userTokenJson.accountName)  {

           redirectToLogin = true;
           let account = this._accService.getAccountByName(userTokenJson.accountName);
           this._accService.removeUserTokenFromAccount(account);
           this._removeCurrentUserFromLocalStore();
           this._userToken = null;
           this.store.purge();
        }

        if (redirectToLogin) {
           this._router.navigate(['accounts/login', userTokenJson.accountName]);
        } else {
            this._router.navigate(['/accounts']);
        }
      }
   }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/services/auth.service.ts